<template>
	<div id="my-reports">
		<!-- Toolbar (for when we decide to filter) -->
		<!-- <div id="my-reports-toolbar" class="Page-section Page-section--flush Page-section--primaryDark">
			<div class="Page-section-inner Page-section-inner--lg">
				<CloToolbar reverse color="primaryDark">
					<CloToolbarGroup>
						<CloToolbarItem label="Filter:" />
						<CloToolbarItem label="Location" href="#" icon="region" dropdown />
						<CloToolbarItem label="Time period" href="#" icon="date" dropdown />
						<CloToolbarItem label="More filters" href="#" icon="filter" dropdown />
					</CloToolbarGroup>
				</CloToolbar>
			</div>
		</div> -->
		<!-- Page heading -->
		<div id="my-reports-heading" class="Page-section Page-section--primaryDark">
			<div class="Page-section-inner Page-section-inner--md">
				<div class="Breadcrumbs Breadcrumbs--reverse">
					<ul>
						<li>
							<a :href="baseUrl + 'myebird'">{{ $t('nav.myEbird') }}</a>
						</li>
					</ul>
				</div>
				<div class="GridFlex GridFlex--flex GridFlex--withGutter GridFlex--alignMiddle">
					<div class="GridFlex-cell u-sizeFill">
						<CloHeading id="content" level="1" size="1" thin reverse utilityClasses="u-margin-none">{{ $t('tripReport.myTripReports') }}</CloHeading>
					</div>
					<div class="GridFlex-cell u-sizeFit">
						<ReportHelp/>
					</div>
				</div>
			</div>
		</div>
		<!-- Create trip report -->
		<div id="my-reports-create" class="Page-section Page-section--primaryLight" :class="myTripReportsList ? '' : 'feature'">
			<div class="Page-section-inner Page-section-inner--md">
				<div id="my-reports-create-content">
					<p class="u-margin-none">{{ $t('tripReport.createDesc') }}</p>
					<span>
						<a v-if="!myTripReportsList" :href="tripReportsLearnMoreUrl" class="Button u-margin-none">{{
							$t('generic.learnMore')
						}}</a>
						<a :href="baseUrl + 'tripreport/create?view=definition'" class="Button Button--highlight u-margin-none">{{
							$t('tripReport.create')
						}}</a>
					</span>
				</div>
			</div>
		</div>
		<!-- My Trip Reports list section -->
		<div v-if="myTripReportsList" id="my-reports-list" class="Page-section">
			<div class="Page-section-inner Page-section-inner--md">
				<!-- Pending invitations -->
				<section v-if="invitedTripReportsList.length > 0" class="u-stack-md">
					<CloHeading level="3">{{ $t('tripReport.pendingInvitations') }}</CloHeading>
					<ul id="invited-reports-items" class="MyTripReports-list MyTripReports-list--highlight">
						<li v-for="invitedTripReport in invitedTripReportsList" :key="invitedTripReport.tripReportId">
							<ReportTitle
								:headingLevel="4"
								:tripId="invitedTripReport.tripReportId"
								:tripName="invitedTripReport.name"
								:tripBeginDt="invitedTripReport.beginDt"
								:tripEndDt="invitedTripReport.endDt"
								:privacySetting="invitedTripReport.privacy"
								:locale="locale"
								:list="true"
							/>
							<div class="MyTripReports-list-actions">
								<button
									class="Button Button--small Button--hollow"
									@click="declineInvitation(invitedTripReport.tripReportId)"
								>
									{{ $t('manageChecklists.decline') }}
								</button>
								<button class="Button Button--small" @click="acceptInvitation(invitedTripReport.tripReportId)">
									{{ $t('tripReport.join') }}
								</button>
							</div>
						</li>
					</ul>
				</section>

				<!-- Main list -->
				<div id="my-reports-list-heading">
					<div id="my-reports-stat">
						<CloStat
							id="stat-reports"
							class="StatsIcon--inline StatsIcon--highlight StatsIcon--lg"
							:stat="totalRows.toString()"
							:label="$t('tripReport.tripReports')"
							current
						></CloStat>
					</div>
					<!-- <CloDropdown id="my-reports-list-sort" icon="triangleDown" :right="true">
						<template v-slot:heading>
							<CloButton class="Button--link">
								<span>{{ $t('mediaSearch.sortType.obs_date_desc.name') }}</span>
							</CloButton>
						</template>
						<template v-slot:panel>
							<span>Add sort options here...</span>
						</template>
					</CloDropdown> -->
				</div>
				<!-- My Trip Reports list -->
				<section>
					<ul id="my-reports-items" class="MyTripReports-list">
						<li v-for="(myTripReport, index) in myTripReportsList" :key="myTripReport.tripReportId">
							<ReportTitle
								:headingLevel="4"
								:tripId="myTripReport.tripReportId"
								:tripName="myTripReport.name"
								:tripBeginDt="myTripReport.beginDt"
								:tripEndDt="myTripReport.endDt"
								:privacySetting="myTripReport.privacy"
								:locale="locale"
								:list="true"
							/>
						</li>
					</ul>
				</section>
				<!-- Pagination -->
				<section v-if="totalRows > defaultRowsPerPage">
					<div id="my-reports-pagination" class="MyTripReports-pagination">
						<!-- # - # of total -->
						<p class="MyTripReports-pagination-context u-margin-none">
							<strong>{{ currentRow }}</strong>
							<span> &ndash; </span>
							<strong>{{ currentEndRow }}</strong>
							<span> {{ $t('summaryView.OfLabelText') }} </span>
							<strong>{{ totalRows }} </strong>
						</p>
						<!-- Previous / Next -->
						<div class="MyTripReports-pagination-prevNext">
							<a v-if="prevHref" :href="prevHref" class="Button Button--hollow">
								<svg class="Icon Icon--arrowLeft" role="presentation">
									<use xlink:href="#Icon--arrowLeft"></use>
								</svg>
								<span>{{ $t('generic.Previous') }}</span>
							</a>
							<a v-if="nextHref" :href="nextHref" class="Button Button--hollow">
								<span>{{ $t('generic.Next') }}</span>
								<svg class="Icon Icon--arrowRight" role="presentation"><use xlink:href="#Icon--arrowRight"></use></svg>
							</a>
						</div>
						<!-- Show all / Hide all -->
						<div class="MyTripReports-pagination-showHide">
							<a v-if="showAllHref" :href="showAllHref" class="Button">
								<span>{{ $t('index.showAll') }}</span>
							</a>
							<a v-if="showFewerHref" :href="showFewerHref" class="Button">
								<span>{{ $t('generic.ShowFewer') }}</span>
							</a>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloBreadcrumbs from '@/navigation/CloBreadcrumbs/CloBreadcrumbs.vue';
import CloToolbar from '@/navigation/CloToolbar/CloToolbar.vue';
import CloToolbarGroup from '@/navigation/CloToolbar/CloToolbarGroup.vue';
import CloToolbarItem from '@/navigation/CloToolbar/CloToolbarItem.vue';
import CloDivider from '@/base/CloDivider/CloDivider.vue';
import CloStat from './components/CloStat.vue';
import ReportTitle from './components/ReportTitle.vue';
import MyReportsReport from './components/MyReportsReport.vue';
import CloDropdown from '@/base/CloDropdown/CloDropdown.vue';
import ReportHelp from './components/ReportHelp.vue';
import CloGridFlex from '@/grid/CloGridFlex/CloGridFlex.vue';

export default {
	name: 'MyTripReportsApp',
	components: {
		CloToolbar,
		CloToolbarGroup,
		CloToolbarItem,
		CloHeading,
		CloBreadcrumbs,
		CloDivider,
		CloStat,
		ReportTitle,
		MyReportsReport,
		CloDropdown,
		ReportHelp,
		CloGridFlex,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			tripManageApiBaseUrl: window.tripManageApiBaseUrl,
			currentRow: parseInt(window.currentRow),
			totalRows: parseInt(window.totalRows),
			rowsPerPage: parseInt(window.rowsPerPage),
			defaultRowsPerPage: 100, // to match default in ebird backend
			csrf: window['_csrf'],
			csrf_header: window['_csrf_header'],
			tripReportsLearnMoreUrl: '#', // get help article url from app properties
			myTripReportsList: window.myTripReports,
			invitedTripReportsList: window.invitedTripReports ? window.invitedTripReports : [],
			isShowingAll: false,
		};
	},
	computed: {
		// get locale by reformating java string fromfor browswer
		locale() {
			let locale = 'en-US';
			// Check for global locale variable set in JSP
			if (window.locale) {
				locale = window.locale.replace('_', '-');
			}
			// console.log(`Locale: ${locale}`);
			return locale;
		},
		prevHref() {
			if (this.currentRow - this.rowsPerPage > 0) {
				let prevStartRow = this.currentRow - this.rowsPerPage;
				return `${this.baseUrl}mytripreports?currentRow=${prevStartRow}&rowsPerPage=${this.rowsPerPage}&order=desc`;
			}
		},
		nextHref() {
			if (this.currentRow + this.rowsPerPage < this.totalRows) {
				let nextStartRow = this.currentRow + this.rowsPerPage;
				return `${this.baseUrl}mytripreports?currentRow=${nextStartRow}&rowsPerPage=${this.rowsPerPage}&order=desc`;
			}
		},
		showAllHref() {
			if (this.totalRows > this.rowsPerPage) {
				return `${this.baseUrl}mytripreports?currentRow=1&rowsPerPage=${totalRows}&order=desc`;
			}
		},
		showFewerHref() {
			if (this.rowsPerPage === this.totalRows) {
				return `${this.baseUrl}mytripreports?currentRow=1&rowsPerPage=100&order=desc`;
			}
		},
		currentEndRow() {
			if (this.currentRow + this.rowsPerPage - 1 < this.totalRows) {
				return this.currentRow + this.rowsPerPage - 1;
			} else {
				return this.totalRows;
			}
		},
	},
	mounted() {},
	methods: {
		declineInvitation(tripId) {
			let url = this.tripManageApiBaseUrl + 'decline-invite/' + tripId;
			let headers = {};
			headers[this.csrf_header] = this.csrf;
			axios
				.delete(
					url,
					{
						headers: headers,
						withCredentials: true,
					},
					{}
				)
				.then((res) => {
					// remove from invited list / remove from display
					this.invitedTripReportsList = this.invitedTripReportsList.filter(function (trip) {
						return trip.tripReportId !== tripId;
					});
				})
				.catch((err) => {
					console.log(err);
				});
		},
		acceptInvitation(tripId) {
			let url = this.tripManageApiBaseUrl + 'accept-invite/' + tripId;
			let headers = {};
			headers[this.csrf_header] = this.csrf;

			axios
				.patch(
					url,
					{},
					{
						headers: headers,
						withCredentials: true,
					}
				)
				.then((res) => {
					// send to manage checklists
					window.location.href = `${baseUrl}tripreport/edit/${tripId}?view=checklists&welcome=true`;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style lang="scss">
@use "sass:color";

html,
body {
	height: unset;
}

.Page.Page--flex {
	min-height: 100vh;
	main {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}
}

// Experimental pattern for lichen consideration
.u-color-vars {
	--color-text: #{$color-text};
	--color-text-muted: #{$color-text-muted};
	--color-link: #{$color-link};
	--color-link-hover: #{$color-link-hover};
	--color-link-border: #{color.adjust($color-link-hover, $alpha: -0.8)};
}
.u-color-vars-reverse {
	--color-text: #{$color-text-reverse};
	--color-text-muted: #{$color-text-muted-reverse};
	--color-link: #{$color-link-reverse};
	--color-link-hover: #{$color-link-hover-reverse};
	--color-link-border: #{color.adjust($color-link-hover-reverse, $alpha: -0.8)};
}

#my-reports {
	flex: 1 1 100%;
	display: flex;
	flex-direction: column;
}
#my-reports-toolbar {
	background-color: $color-primary-6;
	.Toolbar {
		@include breakpoint(large) {
			margin: 0 (-$space-md);
		}
	}
}
#my-reports-create {
	#my-reports-create-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $space-md;
		span {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: $space-md;
		}
	}
	&.feature {
		flex: 1 1 100%;
		#my-reports-create-content {
			background-color: $color-white;
			@include inset-responsive;
			border-radius: $radius-sm;
			flex-direction: column;
			justify-content: center;
		}
	}
}
#my-reports-stat {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	@include stack-md;
}
#my-reports-list {
	.Divider {
		border-color: color.adjust($color-black, $alpha: -0.94);
		margin-left: var(--paddingToFill, -($space-md));
		margin-right: var(--paddingToFill, -($space-md));
		width: calc(100% + calc(var(--paddingtoFill, -($space-md)) * 2));
		@include breakpoint(medium) {
			margin-left: 0;
			margin-right: 0;
			width: 100%;
		}
	}
}
#my-reports-list-heading {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: $space-md;
}
.MyTripReports-list {
	list-style: none;
	background-color: $color-neutral-1;
	display: flex;
	flex-direction: column;
	padding-top: 1px;
	gap: 1px;
	margin-left: var(--paddingToFill, -1rem);
	margin-right: var(--paddingToFill, -1rem);
	[dir='rtl'] & {
		margin-left: var(--paddingToFill, -1rem);
		margin-right: var(--paddingToFill, -1rem);
	}
	width: calc(100% + calc(var(--paddingtoFill, 1rem) * 2));
	@include breakpoint(medium) {
		margin: 0;
		[dir='rtl'] & {
			margin: 0;
		}
		width: 100%;
	}
	li {
		background-color: $color-white;
		@include inset-squish-md;
		@include breakpoint(medium) {
			padding-left: 0;
			padding-right: 0;
		}
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		flex-wrap: wrap;
		column-gap: $space-md;
		row-gap: $space-sm;
	}
	&--highlight {
		background-color: $color-white;
		li {
			background-color: $color-highlight;
			@include breakpoint(large) {
				@include inset-squish-md;
			}
		}
	}
	.MyTripReports-list-actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: $space-sm;
		flex: 1 1 100%;
		@include breakpoint(medium) {
			flex: 0 1 auto;
		}
		.Button {
			margin: 0;
		}
	}
}

.MyTripReports-pagination {
	display: flex;
	gap: $space-md;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: $space-md;
	&-context {
		flex: 1 0 100%;
		@include breakpoint(medium) {
			flex: 0 1 auto;
		}
	}
	&-prevNext {
		display: flex;
		align-items: center;
		gap: $space-sm;
	}
	.Button {
		margin: 0;
		display: inline-flex;
		align-items: center;
		gap: $space-xs;
	}
}

.u-unlist {
	list-style: none;
	margin: 0;
	[dir='rtl'] & {
		margin: 0;
	}
}
</style>
